/**
 * Environment helpers (mirrors beatly-discovery-app pattern for datalake URLs).
 */

/** True when the SPA is served from a local loopback host. */
export function isLocalhost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0'
  );
}

/** True when `VITE_ENVIRONMENT` is the development release stage. */
export function isDevelopment(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'development';
}

export function isProduction(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'production';
}

/**
 * Enable Bugsnag only off localhost and outside the development release stage.
 * Staging/production builds still skip reporting when opened on localhost.
 */
export function shouldEnableErrorReporting(): boolean {
  return !isLocalhost() && !isDevelopment();
}

/**
 * Whether the dev fixture bridge (`localStorage.omni.results.fixtureId`) may
 * serve its canned campaign snapshot instead of the real API.
 *
 * Two independent gates, because they fail differently:
 *  - `MODE` blocks fixtures in a production *build*.
 *  - `isProduction()` blocks them whenever the app is pointed at production
 *    *data*, which `MODE` cannot detect — a local dev server always runs in
 *    `development` mode, so without this check a developer reading live data
 *    would still be shown the fixture, and could misreport a real campaign to
 *    a real client. The key is only ever read, never written, so a stale value
 *    can silently outlive whatever set it.
 */
export function fixturesAllowed(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env.MODE === 'production') return false;
  if (isProduction()) return false;
  return true;
}
